import mapKeys from "lodash/mapKeys";
import snakeCase from "lodash/snakeCase";

export default function snakeCaseKeys(object: Record<string, any>) {
  return mapKeys(object, (value, key) => {
    return snakeCase(key);
  });
}
